import memoizeOne from 'memoize-one';
import type { ExpandedItems } from '../../../../../../model/table';
import type { GenericItem, GenericChildItem } from './types';

export const getLastTopLevelFlatIndex = memoizeOne(
	<ChildItemType extends GenericChildItem, ItemType extends GenericItem<ChildItemType>>(
		items: ItemType[],
		expandedItems: ExpandedItems,
	): number => {
		if (items.length === 0) {
			return 0;
		}

		const lastTopLevelItem = items[items.length - 1];
		const lastIndex = items.reduce(
			(count, item) => count + 1 + (expandedItems[item.id] ? item.childItems.length : 0),
			-1,
		);

		if (expandedItems[lastTopLevelItem.id]) {
			return lastIndex - lastTopLevelItem.childItems.length;
		}

		return lastIndex;
	},
);
